module.exports = __webpack_public_path__ + "static/media/icon2.d12ffa6f.svg";